import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function Compare() {
  const [careers, setCareers] = useState([]);
  const [a, setA] = useState("");
  const [b, setB] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/content/careers").then(({ data }) => {
      setCareers(data);
      if (data[0]) setA(data[0].key);
      if (data[1]) setB(data[1].key);
    }).catch(() => {});
  }, []);

  const compare = async () => {
    if (!a || !b) return;
    setBusy(true);
    try { const { data } = await api.get(`/compare?a=${a}&b=${b}`); setResult(data); }
    catch { } finally { setBusy(false); }
  };

  const rows = result ? [
    ["Fit", `${result.a.fit ?? "—"}%`, `${result.b.fit ?? "—"}%`],
    ["Creativity", `${result.a.creativity}%`, `${result.b.creativity}%`],
    ["Analytical", `${result.a.analytical}%`, `${result.b.analytical}%`],
    ["People interaction", `${result.a.people}%`, `${result.b.people}%`],
    ["Transition difficulty", result.a.transition_difficulty, result.b.transition_difficulty],
    ["Salary (3-5 yr)", result.a.salary_mid, result.b.salary_mid],
  ] : [];

  return (
    <div className="space-y-5">
      <button onClick={() => navigate("/app/career")} className="flex items-center gap-1 text-sm font-semibold text-muted-foreground hover:text-foreground"><ArrowLeft className="h-4 w-4" /> Back</button>
      <h1 className="font-display text-3xl font-extrabold tracking-tight">Compare Careers</h1>

      <div className="grid grid-cols-2 gap-3">
        {[[a, setA], [b, setB]].map(([val, set], i) => (
          <select key={i} value={val} onChange={(e) => set(e.target.value)} data-testid={`compare-select-${i}`}
            className="rounded-xl border border-input bg-card px-3 py-3 text-sm font-semibold outline-none focus:border-indigo-500">
            {careers.map((c) => <option key={c.key} value={c.key}>{c.name}</option>)}
          </select>
        ))}
      </div>
      <button onClick={compare} disabled={busy} data-testid="compare-btn" className="flex w-full items-center justify-center gap-2 rounded-full bg-indigo-600 py-3.5 font-bold text-white hover:bg-indigo-700 disabled:opacity-60">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Compare"}
      </button>

      {result && (
        <div className="overflow-hidden rounded-3xl border border-border bg-card" data-testid="compare-result">
          <div className="grid grid-cols-3 bg-secondary p-4 text-center font-display font-bold">
            <div></div><div className="text-indigo-600">{result.a.name}</div><div className="text-violet-600">{result.b.name}</div>
          </div>
          {rows.map(([label, va, vb], i) => (
            <div key={label} className={`grid grid-cols-3 items-center p-4 text-center text-sm ${i % 2 ? "bg-secondary/40" : ""}`}>
              <div className="text-left font-semibold text-muted-foreground">{label}</div>
              <div className="font-bold">{va}</div><div className="font-bold">{vb}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
